import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/onboarding/_route-wapper')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
